// extracted by mini-css-extract-plugin
export default {"addButton":"FamilyScreen_addButton__uhQUd","sectionOption":"FamilyScreen_sectionOption__P+R2K"};